//import * as d3 from "d3";
import store from "../store";
import axios from "axios";
import * as _ from "lodash";

export default {
  getData: async function() {
    let reports = [];
    /* d3.csv(
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vSL0OG1v6As2ERC7ce7-L-Zpaa85F7U41-lSMeW9PaWhewjUO4B7OJUJEn-mRvYyhBPmK08vGacMvoE/pub?output=csv",
      data => {
        data.forEach(data => {
          //console.log("data ", data["Marcador"].split(','),data["Latitud"],data["Longitud"],parseFloat(data["Latitud"]), parseFloat(data["Longitud"]));
          if (data["Latitud"] != "") {
            reports.push({
              age: data["Edad"],
              folio: data["No. de caso"],
              aggressionDate: data["Fecha del hecho"],
              year: data["Fecha del hecho"].split("/")[2],
              legalName: data["Nombre legal"],
              chosenName: data["Nombre elegido o asumido"],
              nationality: data["Nacionalidad"],
              ageGroup: data["Grupo de edad"],
              ethnicgroup: data["Origen étnico"],
              sex: data["Sexo asignado al nacer"],
              sexualIdentity:
                data["Identidad de género/Orientación sexual percibida"],
              occupation: data["Ocupación"],
              education: data["Nivel educativo"],
              characteristic: data["Característica diferencial"],
              time: data["Hora de los hechos"],
              state: data["Estado de la república mexicana"],
              municipality: data["Ciudad, delegación o municipio"],
              zone: data["Zona"],
              background: data["Antecedentes de violencia"],
              whereWasFound: data["Lugar donde apareció el cuerpo"],
              description: data["Descripción detallada de los hechos"],
              weapon: data["Arma"],
              bodyState: data["Estado del cuerpo"],
              sexualViolence: data["¿Hubo indicios de violencia sexual?"],
              tortureViolence: data["¿Hubo indicios de tortura?"],
              investigation: data["Línea de investigación"],
              wasOffenderFound:
                data["¿Se identificó al presunto responsable de los hechos?"],
              process: data["Estado del proceso"],
              media: data["Medios de comunicación (nota principal)"],
              medialink: data["Link nota principal"],
              lat: parseFloat(data["Latitud"]),
              lng: parseFloat(data["Longitud"]),
              marker: [
                +data["Marcador"].split(',')[0],
                +data["Marcador"].split(',')[1]
              ]
            });
          }
        });
      }
    ); */
    axios
      .get(store.state.host + "api/v1/publicReports", {
        params: {}
      })
      .then(response => {
        //console.log("data", response.data.result);
        response.data.result.forEach(el => {
          el.year = el.aggressionDate.slice(0,4);
        });
        store.commit("setReports", response.data.result);
        this.filterData();
      })
      .catch(error => {
        console.log(error);
      });
    //store.commit("setReports", reports);
    //this.filterData();
  },
  getOptions() {
    axios
      .get(store.state.host + "api/v1/options", {
        params: {}
      })
      .then(response => {
        // console.log("options", response.data.result);
        store.commit("setOptions", response.data.result);
      })
      .catch(error => {
        console.log(error);
      });
  },
  filterData() {
    let filteredReports = store.state.reports;

    if (
      store.state.filters.sexualIdentity &&
      store.state.filters.sexualIdentity !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        // console.log(report.folio)
        return report.sexualIdentity === store.state.filters.sexualIdentity;
      });
    }
    // console.log(filteredReports, "sexualIdentity");

    if (store.state.filters.state && store.state.filters.state !== "Todas") {
      filteredReports = filteredReports.filter(report => {
        return report.state === store.state.filters.state;
      });
    }
    //console.log(filteredReports, "state");

    if (
      store.state.filters.ageGroup &&
      store.state.filters.ageGroup !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        return report.ageGroup === store.state.filters.ageGroup;
      });
    }
    //console.log(filteredReports, "age");

    if (
      store.state.filters.characteristic &&
      store.state.filters.characteristic !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        return report.characteristic === store.state.filters.characteristic;
      });
    }

    if (
      store.state.filters.period
    ) {
      filteredReports = filteredReports.filter(report => {
        return report.year >= store.state.filters.period[0] && report.year <= store.state.filters.period[1];
      });
    }

    if (
      store.state.filters.occupation &&
      store.state.filters.occupation !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        return report.occupation === store.state.filters.occupation;
      });
    }

    if (
      store.state.filters.whereWasFound &&
      store.state.filters.whereWasFound !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        return report.whereWasFound === store.state.filters.whereWasFound;
      });
    }

    if (
      store.state.filters.weapon &&
      store.state.filters.weapon !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        return report.weapon === store.state.filters.weapon;
      });
    }

    if (
      store.state.filters.wasOffenderFound &&
      store.state.filters.wasOffenderFound !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        return report.wasOffenderFound === store.state.filters.wasOffenderFound;
      });
    }

    if (
      store.state.filters.bodyState &&
      store.state.filters.bodyState !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        return report.bodyState === store.state.filters.bodyState;
      });
    }

    if (
      store.state.filters.sexualViolence &&
      store.state.filters.sexualViolence !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        return report.sexualViolence === store.state.filters.sexualViolence;
      });
    }

    if (
      store.state.filters.tortureViolence &&
      store.state.filters.tortureViolence !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        return report.tortureViolence === store.state.filters.tortureViolence;
      });
    }

    //console.log(filteredReports, "filtros");
    store.commit("setFilteredReports", filteredReports);
    const filteredStates = [...new Set([...filteredReports.map(el => {
      return el.state;
    })])].sort();
    store.commit("setFilteredStates", filteredStates);
    store.commit("setSelection", undefined);
  }
};
